import API from 'services/API/index';

export default function fetchBankCards() {
  return API.request({
    method: 'GET',
    url: '/pay/cards',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
